// @ts-nocheck
export const en = {
  nav: {
    dashboard: 'Dashboard',
    projects: 'Projects',
    knowledgeBase: 'Agent Training',
    conversations: 'Conversations',
    agentWorkspace: 'Agent Workspace',
    analytics: 'Analytics',
    settings: 'Settings',
  },
  common: {
    send: 'Send',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    search: 'Search',
    loading: 'Loading...',
    export: 'Export',
    copy: 'Copy',
    view: 'View',
    viewAll: 'View all',
    create: 'Create',
    edit: 'Edit',
    close: 'Close',
    add: 'Add',
    or: 'or',
  },
  auth: {
    welcomeBack: 'Welcome back',
    signInSubtitle: 'Sign in to manage your AI customer service',
    continueWithGoogle: 'Continue with Google',
    signInWithGoogle: 'Sign in with Google',
    agreeToTerms: 'By signing in, you agree to our',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    and: 'and',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    companyName: 'Company Name',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    resetPassword: 'Reset Password',
    resetPasswordDesc: 'Enter your email and we will send you a password reset link.',
    resetEmailSent: 'Password reset email sent. Please check your inbox.',
    sendResetEmail: 'Send Reset Email',
    backToLogin: 'Back to login',
    errorUserNotFound: 'No account found with this email',
    errorWrongPassword: 'Incorrect password',
    errorEmailInUse: 'Email already registered',
    errorWeakPassword: 'Password too weak (minimum 6 characters)',
    errorInvalidEmail: 'Invalid email address',
    errorTooManyRequests: 'Too many attempts. Please try again later',
    errorPasswordMismatch: 'Passwords do not match',
    errorGeneric: 'Operation failed. Please try again',
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: "Welcome back! Here's what's happening with your customer support today.",
    todayConversations: "Today's Conversations",
    activeUsers: 'Active Users',
    resolutionRate: 'Resolution Rate',
    avgResponseTime: 'Avg Response Time',
    vsLastWeek: 'vs last week',
    monthlyConversations: 'Monthly Conversations',
    plan: 'plan',
    used: 'used',
    approachingLimit: "You're approaching your monthly limit. Consider upgrading for uninterrupted service.",
    limitReached: 'Monthly conversation limit reached.',
    upgradePlan: 'Upgrade Plan',
    recentConversations: 'Recent Conversations',
    topTopics: 'Top Topics',
    lastMessage: 'Last message',
    resolved: 'Resolved',
    minAgo: 'min ago',
  },
  conversations: {
    title: 'Conversations',
    subtitle: 'View and manage customer conversations.',
    all: 'all',
    active: 'active',
    ended: 'ended',
    escalated: 'escalated',
    noConversationsFound: 'No conversations found',
    session: 'Session',
    messages: 'messages',
    selectConversation: 'Select a conversation to view details',
    sources: 'Sources',
    msgs: 'msgs',
  },
  knowledgeBase: {
    title: 'Knowledge Base',
    subtitle: 'Manage your documents and Q&A pairs to improve AI responses.',
    uploadDocument: 'Upload Document',
    addQA: 'Add Q&A',
    searchPlaceholder: 'Search documents and Q&A...',
    documents: 'Documents',
    qa: 'Q&A',
    noDocumentsFound: 'No documents found',
    noQAFound: 'No Q&A pairs found',
    adjustSearch: 'Try adjusting your search terms.',
    getStartedDocument: 'Get started by uploading a document.',
    getStartedQA: 'Get started by creating a Q&A pair.',
    created: 'Created',
    updated: 'Updated',
    uploadDocumentTitle: 'Upload Document',
    uploadDescription: 'Upload PDF, Word, or text files to train your AI assistant.',
    clickToUpload: 'Click to upload or drag and drop',
    fileFormats: 'PDF, DOC, DOCX, TXT up to 10MB',
    addQAPair: 'Add Q&A Pair',
    question: 'Question',
    answer: 'Answer',
    questionPlaceholder: 'What is your return policy?',
    answerPlaceholder: 'Our return policy allows returns within 30 days...',
  },
  settings: {
    title: 'Settings',
    subtitle: 'Configure your widget, manage API keys, and control team access.',
    widgetConfiguration: 'Widget Configuration',
    apiSettings: 'API Settings',
    escalation: 'Escalation',
    billingUsage: 'Billing & Usage',
    teamManagement: 'Team Management',
    widgetAppearance: 'Widget Appearance',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    auto: 'Auto',
    primaryColor: 'Primary Color',
    position: 'Position',
    bottomRight: 'Bottom Right',
    bottomLeft: 'Bottom Left',
    topRight: 'Top Right',
    topLeft: 'Top Left',
    welcomeMessage: 'Welcome Message',
    messagePlaceholder: 'Message Placeholder',
    features: 'Features',
    showAvatar: 'Show Avatar',
    showTimestamps: 'Show Timestamps',
    allowFileUploads: 'Allow File Uploads',
    widgetIntegration: 'Widget Integration',
    widgetIntegrationDesc: "Copy and paste this code snippet into your website's <head> section to add the ClawCustomer chat widget.",
    asyncLoad: "The widget will load asynchronously and won't affect your page load performance.",
    apiConfiguration: 'API Configuration',
    primaryApiKey: 'Primary API Key',
    apiKeySecret: "Keep your API key secret. It's used to authenticate requests to the ClawCustomer API.",
    webhookUrl: 'Webhook URL (Optional)',
    webhookDesc: 'Receive real-time notifications about new conversations and messages.',
    rateLimit: 'Rate Limit (requests per minute)',
    escalationConfiguration: 'Escalation Configuration',
    escalationDesc: 'Configure automatic escalation to human agents via Telegram when AI cannot resolve a query.',
    enableEscalation: 'Enable Escalation to Human Agent',
    telegramBotToken: 'Telegram Bot Token',
    telegramChatId: 'Telegram Chat ID',
    triggerKeywords: 'Trigger Keywords',
    triggerKeywordsDesc: 'Comma-separated keywords. AI responses containing these will trigger escalation.',
    handoffMessage: 'Handoff Message',
    handoffMessageDesc: 'Message shown to the user when escalation is triggered.',
    sendTestMessage: 'Send Test Message',
    sending: 'Sending...',
    testSuccess: 'Test message sent successfully!',
    testFailed: 'Failed to send test message. Check your configuration.',
    billingTitle: 'Billing & Usage',
    billingDesc: 'Manage your subscription, view usage, and update billing information.',
    teamMembers: 'Team Members',
    teamDesc: 'Manage who has access to your ClawCustomer account.',
    inviteMember: 'Invite Member',
    emailAddress: 'Email Address',
    role: 'Role',
    status: 'Status',
    joined: 'Joined',
    member: 'Member',
    admin: 'Admin',
    inviteTeamMember: 'Invite Team Member',
    sendInvitation: 'Send Invitation',
    saveSettings: 'Save Settings',
    saving: 'Saving...',
  },
  projects: {
    title: 'Projects',
    subtitle: 'Manage your chat widgets and integrations across different websites and applications.',
    newProject: 'New Project',
    status: 'Status',
    conversations: 'Conversations',
    apiKey: 'API Key',
    createNewProject: 'Create New Project',
    projectName: 'Project Name',
    domain: 'Domain',
    createProject: 'Create Project',
  },
  analytics: {
    title: 'Analytics',
    subtitle: 'Track your customer support performance and identify improvement opportunities.',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    last90Days: 'Last 90 days',
    totalConversations: 'Total Conversations',
    resolutionRate: 'Resolution Rate',
    avgResponseTime: 'Avg Response Time',
    satisfactionScore: 'Satisfaction Score',
    conversationTrends: 'Conversation Trends',
    total: 'Total',
    resolved: 'Resolved',
    mostAskedQuestions: 'Most Asked Questions',
    responseTimeByHour: 'Response Time by Hour',
    averageSeconds: 'Average seconds',
    customerSatisfaction: 'Customer Satisfaction',
    outOf5: 'Out of 5.0',
  },
  layout: {
    signOut: 'Sign out',
    openSidebar: 'Open sidebar',
    closeSidebar: 'Close sidebar',
    notifications: 'View notifications',
    switchToEnglish: 'English',
    switchToChinese: '中文',
  },
  toast: {
    signInSuccess: 'Signed in successfully!',
    signInFailed: 'Failed to sign in',
    signUpSuccess: 'Account created successfully!',
    signUpFailed: 'Failed to create account',
    googleSignInSuccess: 'Signed in with Google!',
    completeSetup: 'Please complete your setup',
    googleSignInFailed: 'Failed to sign in with Google',
    resetEmailSent: 'Password reset email sent',
    resetEmailFailed: 'Failed to send reset email',
    signOutSuccess: 'Signed out successfully',
    signOutFailed: 'Failed to sign out',
    profileLoadFailed: 'Failed to load user profile',
  },
  billing: {
    unableToLoad: 'Unable to Load Subscription',
    unableToLoadDesc: "We couldn't fetch your subscription information.",
    tryAgain: 'Try Again',
    currentPlan: 'Current Plan',
    conversationsUsed: 'Conversations Used',
    usageLimitExceeded: 'Usage limit exceeded',
    approachingLimit: 'Approaching usage limit',
    nextBilling: 'Next billing: ',
    billingPeriod: 'Billing: ',
    cancelNotice: 'Your subscription will be canceled at the end of the current billing period.',
    upgradeToStarter: 'Upgrade to Starter',
    upgradeToPro: 'Upgrade to Pro',
    upgradeToBusiness: 'Upgrade to Business',
    manageSubscription: 'Manage Subscription',
    processing: 'Processing...',
    planComparison: 'Plan Comparison',
    perMonth: '/month',
    conversations: 'Conversations',
    projects: 'Projects',
    statusActive: 'Active',
    statusTrial: 'Trial',
    statusCanceled: 'Canceled',
    statusPastDue: 'Past Due',
    statusIncomplete: 'Incomplete',
    free: 'Free',
    starter: 'Starter',
    pro: 'Pro',
    business: 'Business',
    enterprise: 'Enterprise',
  },
  placeholders: {
    welcomeMessage: 'Hi! How can I help you today?',
    typeMessage: 'Type your message...',
    handoffMessage: 'Your conversation is being transferred to a human agent. Please wait.',
    telegramHelp: 'Get this from @BotFather on Telegram.',
    triggerKeywords: 'human agent, speak to someone, escalate, manager',
    webhookUrl: 'https://your-site.com/webhook',
    inviteEmail: 'colleague@example.com',
    projectName: 'My Website',
    projectDomain: 'mywebsite.com',
    typeResponse: 'Type your response...',
    pressEnterToSend: 'Press Enter to send, Shift+Enter for new line',
  },
  agent: {
    workspace: 'Agent Workspace',
    disconnected: 'Disconnected',
    currentChats: 'Current chats',
    online: 'Online',
    away: 'Away',
    offline: 'Offline',
    pending: 'Pending',
    noQueuedSessions: 'No queued sessions',
    newSession: 'New session',
    unknownProject: 'Unknown project',
    myChats: 'My Chats',
    noActiveChats: 'No active chats',
    chatting: 'Chatting',
    humanAgentConnected: 'Live agent connected',
    selectSession: 'Select a session to start',
    selectSessionHint: 'Click a session from the list',
    humanMode: 'Human agent',
    queuedMode: 'Queued',
    escalationReason: 'Escalation reason',
    backToAI: 'Back to AI',
    addNote: 'Add Note',
    closeSession: 'Close Session',
    noMessages: 'No messages yet',
    inputPlaceholder: 'Type a message... (Enter to send, Shift+Enter for new line)',
    addNotePrompt: 'Add note:',
    session: 'Session',
    userChat: 'User chat',
    agent: 'Agent',
  },
}
